













import { StoreManagementStoreService } from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import LiveItemPdfComponent from "@/components/admin/live/common/liveItemPdfComponent.vue";
import QInputMultipleLanguage from "@/components/common/qInputMultipleLanguage.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ImportItemsComponent",
  components: {
    QCalendar,
    QInputMultipleLanguage,
    LiveItemPdfComponent,
    QErrors,
  },
})
export default class ImportItemsComponent extends Vue {
  public name: "ImportItemsComponent";
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public errors;

  public uploadFile() {
    const input = this.$refs.fileInput as HTMLInputElement;
    input.click();
  }

  public async importCsv(event) {
    this.$emit("update:errors", []);
    let result;
    try {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("csv", file);

      result = await StoreManagementStoreService.adminStoreImport(
        formData as any,
      );

      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });

        this.$emit("success");
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.$emit("update:errors", result.body.errors);
      }
    }

    const input = this.$refs.fileInput as HTMLInputElement;
    input.value = null;
  }
}
